import prescription from "@/data/prescriptionData";

const state = () => ({
  prescription: prescription,
});

const getters = {
  // TODO: Top5List.vue 에서 사용하는데 이 Vue 자체가 사용되지 않는 것 같긴 한데 좀 두고 봐야 할 듯.
  getElapsedDaysTop5: function (state) {
    return state.patientList.sort(function (a, b) {
      if (a.elapsedDays < b.elapsedDays) return 1;
      if (a.elapsedDays > b.elapsedDays) return -1;
      return 0;
    });
  },
};

const mutations = {};

const actions = {};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
